import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext"; // Import the useAuth hook

const Logout = () => {
    const { logout } = useAuth(); // Use the logout function from AuthContext
    const navigate = useNavigate(); // React Router hook for navigation

    useEffect(() => {
        // Call the logout function when the component mounts
        logout();
        // Redirect to the login page or any page you desire
        navigate("/login");
    }, [logout, navigate]);

    // Optional: You can add a loading message while logging out
    return <div>Logging out...</div>;
};

export default Logout;
